import { getComposeEvent } from '../selectors/getComposeEvent';

export function getAttendeeLists() {
    const event = getComposeEvent();
    return event ? [event.RequiredAttendees, event.OptionalAttendees] : [];
}

export function getAllAttendees() {
    let attendeeLists = getAttendeeLists();
    return [...attendeeLists[0], ...attendeeLists[1]];
}
